<ngb-tab id="tab-selectbyid3">
    <ng-template ngbTabTitle>Approve PDF</ng-template>
    <div class="row mt-2">
        <div class="col-md-4 float-right ml-auto">
            <div class="row">
                <label for="inputEmail3" class="col-sm-3 col-form-label text-right pr-1">Search:</label>
                <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                    style="width: 250px !important; float: right;">
                    <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword"
                        placeholder="Search" (keyup.enter)="getOrderDetails()" />
                    <span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
                        style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;"
                        (click)="getOrderDetails();">
                    </span>
                    <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
                        title="Clear" (click)="getOrderDetails();">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                            class="bi bi-x" viewBox="0 0 16 16" (click)="clearUserData()" (clearEvent)="searchword=''"
                            *ngIf="searchword">
                            <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                    </span>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row animated fadeIn">
        <div class="col-md-12">
            <div class="form-row">
                <div class="col-lg-2 col-md-4 col-sm-6" *ngFor="let doc of orderdoc; index as i;">

                    <div class="card shadow-sm rounded-0 border">
                        <div class="document-img-box">
                            <img src="{{url+doc.UrlPath}}" alt="image" class="img-thumbnail company document-img">
                        </div>

                        <div ngbDropdown class="d-inline-block p-2 list-dropdown-box">
                            <a href="javascript:void(0);" class="card-link text-dark"><i
                                    class="mdi mdi-image mdi-24"></i> {{ (doc.FileName.length>15)?
                                (doc.FileName |
                                slice:0:15)+'...':(doc.FileName ) }} </a>
                            <a href="javascript:void(0);" class="float-right"> </a>
                            <i class="mdi mdi-dots-vertical mdi-24" id="dropdownBasic1" ngbDropdownToggle></i>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class=" dropdown-menu-right">
                                <a href="javascript:void(0);" (click)="detailOpenModal(detailConfirm, doc)">
                                    <button ngbDropdownItem><i class="mdi mdi-information-outline"></i> Detail
                                        Info</button></a>
                                <ng-container *ngIf="userRId == 1">
                                    <a href="javascript:void(0);" (click)="deleteOpenModal(deleteConfirm, doc)">
                                        <button ngbDropdownItem><i class="mdi mdi-delete"></i> Delete</button></a>
                                </ng-container>
                                <ng-container *ngIf="permission.OrderReview_AttachmentDownload==1 ||userRId == 1">
                                    <a href="javascript:void(0);"
                                        (click)="downloadModal(downloadConfirm, doc.FileId, downloadurl+doc.FileName, doc.FileName)">
                                        <button ngbDropdownItem><i class="mdi mdi-cloud-download"></i>
                                            Download</button> </a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="orderdoc == 0" class="text-center">
        No Record found.
    </div>
</ngb-tab>

<ng-template #downloadConfirm>
    <div class="modal-body text-center">
        <p>Do you want to Download {{pdfname}}?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="download(orderdoc.FileName); modalRef.hide();"
            [disabled]="delNameDel">Download</button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
    </div>
</ng-template>

<ng-template #deleteConfirm>
    <div class="modal-body text-center">
        <p>Do you want to delete {{filesname}}?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="deletefileinfo(); modalRef.hide();"
            [disabled]="delNameDel">Delete</button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
    </div>
</ng-template>

<ng-template #detailConfirm>
    <div class="modal-body text-center">
        <p>Detail Info :-</p>
        <p>File Name - {{filesname}}</p>
        <p>Created By - {{createdBy}}</p>
        <p>Created Date - {{createdDate}} {{createdTime}}</p>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">OK</button>
    </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>